export const CTA_URL = 'https://decisionclinica.impultienda.ar/checkout/facial'

export const PRICE = '$12.99 USD'

export const COUNTDOWN_SECONDS = 17 * 60 + 34

export const IMAGES = {
  mockup:
    'https://cdn.magicpatterns.com/uploads/8w7qGwXfMNm51FnPRdEhy6/reparaciones_mockup_sin_fondo-4.png',
  bono1: 'https://cdn.magicpatterns.com/uploads/d1t6fk2dw6nXeidoiTVTps/BONO_1_FACIAL.png',
  bono2: 'https://cdn.magicpatterns.com/uploads/5ftr7UVxSH4t1gToXcKZG5/BONO_2_FACIAL.png',
  bono3: 'https://cdn.magicpatterns.com/uploads/2Lrxk4v9LuRsAmuUYrJ5S9/BONO_3_FACIAL.png',
  bono4: 'https://cdn.magicpatterns.com/uploads/uwTvLeBWS436VkDsXWRYuK/BONO_4_FACIAL.png',
  bono5: 'https://cdn.magicpatterns.com/uploads/t1w4qzSPqgNzzApgUH7iMs/BONO_5_FACIAL.png',
  drKarito:
    'https://cdn.magicpatterns.com/patterns/generated-images/3dd8d52d-6140-4d3b-8d0f-f5e3c431a06e.jpg',
  t1: 'https://cdn.magicpatterns.com/patterns/generated-images/3e8170d1-c026-48b0-a6c7-2d6bec2f5573.jpg',
  t2: 'https://cdn.magicpatterns.com/patterns/generated-images/c811e9a2-73e2-4b7f-b478-0e71ae0deb17.jpg',
  t3: 'https://cdn.magicpatterns.com/patterns/generated-images/153a4334-2252-43dc-909e-e6945882d250.jpg',
}

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void
  }
}

export function trackCheckoutClick(location: string): void {
  if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
    window.fbq('track', 'InitiateCheckout', {
      content_name: 'Sistema de Diagnostico Facial',
      value: 12.99,
      currency: 'USD',
      source_section: location,
    })
  }
}
